function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "g1713",
  transform: "translate(1 1)"
}, React.createElement("path", {
  id: "path1245",
  d: "M-239.46-110.08h15",
  transform: "translate(239.46 117.58)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "path1709",
  d: "M-151.568-197.971v15",
  transform: "translate(159.068 197.971)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/plus.742bd79c.svg";
export { SvgComponent as ReactComponent };